import * as React from 'react';
import { ForwardedRef, forwardRef, MouseEvent } from 'react';
import { IMaskedInputProps, MaskedInput, IInputProps as IInputUiProps, Input as InputUi } from '@cian/ui-kit';
import cn from 'clsx';

import * as styles from './styles.css';
import { CrossSmall24 } from '../../Icons';

type TInputProps =
  | (Omit<IMaskedInputProps, 'onChange'> | Omit<IInputUiProps, 'onChange'>) & {
      onChange?(value: string): void;
    };

export const Input = forwardRef(
  (
    { onChange, invalid, disabled, value, rightAdornment, ...props }: TInputProps,
    ref?: ForwardedRef<HTMLInputElement>,
  ) => {
    const handleClear = (e: MouseEvent) => {
      e.preventDefault();

      if (onChange) {
        onChange('');
      }
    };

    const handleInputChange: IInputUiProps['onChange'] = (e, value) => {
      if (onChange) {
        onChange(value);
      }
    };

    const handleMaskedInputChange: IMaskedInputProps['onChange'] = value => {
      if (onChange) {
        onChange(value);
      }
    };

    const inputProps = {
      ref,
      rightAdornment: (
        <div className={styles['right-adornments']}>
          {value && (
            <div onClick={handleClear}>
              <CrossSmall24 color="currentColor" />
            </div>
          )}
          {value && rightAdornment && <div className={styles['adornment-separator']} />}
          {rightAdornment}
        </div>
      ),
      value,
      invalid,
      disabled,
      ...props,
    };

    return (
      <div className={cn(styles.wrapper, invalid && styles.invalid, disabled && styles.disabled)}>
        {!('mask' in props) && <InputUi onChange={handleInputChange} {...(inputProps as IInputUiProps)} />}
        {'mask' in props && <MaskedInput onChange={handleMaskedInputChange} {...(inputProps as IMaskedInputProps)} />}
      </div>
    );
  },
);

Input.displayName = 'Input';
